import React, { useEffect } from "react";
import {
  FlatList,
  Text,
  View,
  StyleSheet,
  TouchableOpacity,
} from "react-native";
import { FONT_FAMILY, THEME_COLORS } from "../../../common/themes";
// import styles from "./styles";

const NotificatioCard = ({ item }: any) => {
  return (
    <View style={styles.notification}>
      <Text style={styles.notifTime}>May 17, 2022 by Sujit Kumar</Text>
      <Text style={styles.notifTxt}>
        Your service equipment has been updated
      </Text>
      <Text style={styles.descreption}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
        tempor adipiscing elit, sed do eiusmod tempor dolor sit amet,
        consectetur
      </Text>
    </View>
  );
};

const Notifications = ({ route, navigation }: NotificationsProps) => {
  return (
    <View style={styles.container}>
      <FlatList
        data={[1, 2, 4, 9, 10, 90, 98, 1, 2]}
        keyExtractor={(_, i) => i.toString()}
        renderItem={({ item }) => <NotificatioCard item={item} />}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  headerSt: {
    backgroundColor: "white",
    elevation: 3,
    justifyContent: "center",
    minHeight: 50,
    paddingTop: 0,
    marginBottom: 5,
  },
  container: {
    backgroundColor: "rgba(99, 0, 163, 0.04)",
    flex: 1,
    height: '90%',
    marginTop: 20,
  },
  notification: {
    borderBottomWidth: 2,
    borderColor: THEME_COLORS.border2,
    paddingHorizontal: 20,
    paddingVertical: 10,
  },
  notifTxt: {
    fontSize: 17,
    color: THEME_COLORS.black,
    fontFamily: FONT_FAMILY.primary,
  },
  notifTime: {
    fontSize: 14,
    color: THEME_COLORS.textGrey,
    alignSelf: "flex-start",
    fontFamily: FONT_FAMILY.primary,
    marginTop: 10,
  },
  descreption: {
    marginTop: 10,
    fontSize: 14,
    color: THEME_COLORS.textGrey,
    fontFamily: FONT_FAMILY.primary,
  },
});

export default Notifications;
